export type SlideToggleValue = boolean | null;
